class ValidateCups {
    private static cups: string;

    constructor() {
        throw new Error("ValidateCups class cannot be instantiated directly. Use of() instead.");
    }

    static of(cups: string) {
        this.cups = cups;
        return this.validate();
    }

    private static validate(): boolean {
        let result: boolean = false;

        if (this.cups.startsWith("ES") && this.cups.length >= 20) {
            result = true;
        }

        return result;
    }
}

//removeIf(production)
export default ValidateCups;
//endRemoveIf(production)